/**
 * Calculates the payment for a loan based on constant payments and a constant interest rate.
 *
 * @param {number} interestRate
 * @param {number} currentBalance
 * @param {number} totalPaymentMonths
 * @returns {number} The monthly payment amount
 */
export default function calculatePMT({ interestRate, currentBalance, totalPaymentMonths }) {
    if (!interestRate || !currentBalance || !totalPaymentMonths) {
        return;
    }

    const rate = interestRate / 100;

    // Formula is P = (Pv*R) / [1 - (1 + R)^(-n)]
    return (currentBalance * (rate / 12)) / (1 - Math.pow((1 + (rate / 12)), (-1 * totalPaymentMonths)));
}